import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { NetworkDataRequest } from '../../requests/test-network/network-data.request';
import { TestDownloadResponse } from '../../responses/test-network/test-download.response';

@Injectable({
  providedIn: 'root'
})
export class TestDownloadService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public downloadTest(): Observable<TestDownloadResponse> {

    let uri = `TestDownload`

    return this.httpClient.get<TestDownloadResponse>(environment.urlApiTestNetwork + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public saveTestData(body: NetworkDataRequest): Observable<ReturnStruct> {

    let uri = `TestDownload`

    return this.httpClient.post<ReturnStruct>(environment.urlApiTestNetwork + uri, body,this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}